function combineFilterOption({ columnName, comparator, value }) {
  return `${columnName}|${comparator}|${value}`;
}

export function getFilterOption({ columnName, comparator, value }) {
  if (columnName && comparator && typeof value !== 'undefined') {
    return { columnName, comparator, value };
  }
}

export function getFilterCombinations(filters) {
  const filterCombinations = [];
  filters.forEach((filterOption) => {
    const combination = combineFilterOption(filterOption);
    if (!filterCombinations.includes(combination)) {
      filterCombinations.push(combination);
    }
  });

  return filterCombinations;
}

export function mapFilterOptions({
  name: label,
  column_name,
  field,
  comparator,
  value,
}) {
  return {
    columnName: column_name || field,
    comparator,
    value,
    label,
  };
}

function mapFilters({
  label: fieldName,
  filter_column_name: columnName,
  displayed_name: label,
  tooltip_text: tooltip,
  min_value: minValue,
  max_value: maxValue,
  slider_type: sliderType,
  min_value_label_template: minValueLabelTemplate,
  current_value_label_template: currentValueLabelTemplate,
  max_value_label_template: maxValueLabelTemplate,
  steps: stepSize,
  type,
  options,
  optionDefaultValue,
  prefix,
  suffix,
}) {

  return {
    type: type.toLowerCase(),
    options,
    optionDefaultValue,
    fieldName,
    columnName,
    label,
    tooltip,
    minValue,
    maxValue,
    sliderType,
    minValueLabelTemplate,
    currentValueLabelTemplate,
    maxValueLabelTemplate,
    stepSize,
    prefix,
    suffix,
  };
}

export function reduceFilters(filtersToReduce, filtersToCompare, shouldReturnMatched = true) {
  const filterCombinations = getFilterCombinations(filtersToCompare);
  
  return filtersToReduce.reduce((reducedFilter, filter) => {
    if (filterCombinations.includes(combineFilterOption(filter)) === shouldReturnMatched) {
      reducedFilter.push(getFilterOption(filter));
    }

    return reducedFilter;
  }, []);
}

export function getDataConfig(config) {
  const jsonData = JSON.parse(config);
  const defaultTableFilter = jsonData.default_table_filters || [];

  return {
    filters: jsonData.filter_fields || {},
    defaultTableFilter: defaultTableFilter.map(mapFilterOptions),
  }
}

export function formatFilters(filters, defaultTableFilter) {
  let tableFilters = defaultTableFilter;
  const updatedFilters = Object.values(filters).map((currentFilter) => {
    const options = currentFilter.options.map(mapFilterOptions);
    const optionDefaultValue = reduceFilters(options, defaultTableFilter);
    const filter = {
      ...currentFilter, 
      options,
      optionDefaultValue,
    };

    tableFilters = reduceFilters(tableFilters, optionDefaultValue, false);

    return mapFilters(filter);
  });

  return {
    filters: updatedFilters,
    defaultTableFilter: tableFilters,
  };
}



// WEBPACK FOOTER //
// ./src/utils/FilterConfigFormatter.js